import { defineStore } from 'pinia';
import { ref } from 'vue';

export const PPS_PLAY = Symbol('PlayPauseStatePlaying');
export const PPS_PAUSE = Symbol('PlayPauseStatePaused');
const acceptedStates = [PPS_PLAY, PPS_PAUSE];

type PlayPauseState = typeof PPS_PLAY | typeof PPS_PAUSE;

export const usePlayPauseStore = defineStore('playPause', () => {
  const playPauseState = ref<Record<string, PlayPauseState>>({});

  function setPlayPauseState ({ uuid, value }: { uuid: string, value: PlayPauseState }) {
    if (acceptedStates.includes(value)) {
      playPauseState.value[uuid] = value;
    }
  }

  /* removePlayPauseState ({ uuid }) {
    del(this.playPauseState, uuid);
  }, */
  return {
    playPauseState,
    setPlayPauseState,
  };
});
